import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'contract_found_not_num.title',
  },
  subTitle: {
    id: 'contract_found_not_num.sub_title',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
});
